<template>
    <!-- Request Modal -->
		<div class="modal custom-modal fade request-modal" id="request-court" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-md">
				<div class="modal-content">
					<div class="modal-header">
						<div class="form-header modal-header-title">
							<h4 class="mb-0">Court Request</h4>
						</div>
						<a class="close" data-bs-dismiss="modal" aria-label="Close">
							<span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
						</a>
					</div>
					<div class="modal-body">

						<!-- Court Request -->
						<div class="row">
							<div class="col-lg-12">
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Court Information</h4>
									</div>
									<div class="appointment-info">
										<ul>
											<li>
												<div class="appointment-item">
													<div class="appointment-img">
														<img src="@/assets/img/booking/booking-01.jpg" alt="User">
													</div>
													<div class="appointment-content">
														<h6>Wing Sports Academy</h6>
														<p class="color-green">Court 1</p>
													</div>
												</div>
											</li>
											<li>
												<h6>Booked On</h6>
												<p>$150 Upto 2 guests</p>
											</li>
											<li>
												<h6>Price Per Guest</h6>
												<p>$15</p>
											</li>
											<li>
												<h6>Maximum Number of Guests</h6>
												<p>2</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Appointment Information</h4>
									</div>
									<div class="appointment-info appoin-border">
										<ul>
											<li>
												<h6>Booked On</h6>
												<p>$150 Upto 2 guests</p>
											</li>
											<li>
												<h6>Price Per Guest</h6>
												<p>$15</p>
											</li>
											<li>
												<h6>Maximum Number of Guests</h6>
												<p>2</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Payment Details</h4>
									</div>
									<div class="appointment-info appoin-border double-row">
										<ul>
											<li>
												<h6>Court Booking Amount</h6>
												<p>$150</p>
											</li>
											<li>
												<h6>Additional Guests</h6>
												<p>2</p>
											</li>
											<li>
												<h6>Amount Additional Guests</h6>
												<p>$30</p>
											</li>
											<li>
												<h6>Service Charge</h6>
												<p>$20</p>
											</li>
										</ul>
									</div>
									<div class="appointment-info appoin-border ">
										<ul>
											<li>
												<h6>Total Amount Paid</h6>
												<p class="color-green">$180</p>
											</li>
											<li>
												<h6>Paid On</h6>
												<p>Mon, Jul 14</p>
											</li>
											<li>
												<h6>Transaction ID</h6>
												<p>#5464164445676781641</p>
											</li>
											<li>
												<h6>Payment type</h6>
												<p>Wallet</p>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<!-- /Court Request -->

					</div>
					<div class="modal-footer">
						<div class="table-accept-btn">
							<a href="javascript:;" class="btn accept-btn"><i class="feather-check-circle"></i>Accept</a>
							<a href="javascript:;" class="btn cancel-table-btn"><i
									class="feather-x-circle"></i>Cancel</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Request Modal -->

		<!-- Request Reject -->
		<div class="modal custom-modal fade request-modal" id="request-reject" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-md">
				<div class="modal-content">
					<div class="modal-header">
						<div class="form-header modal-header-title">
							<h4 class="mb-0">Court Reject Reason</h4>
						</div>
						<a class="close" data-bs-dismiss="modal" aria-label="Close">
							<span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
						</a>
					</div>
					<div class="modal-body">

						<!-- Court Request -->
						<div class="row">
							<div class="col-lg-12">
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Court Information</h4>
									</div>
									<div class="appointment-info">
										<ul>
											<li>
												<div class="appointment-item">
													<div class="appointment-img">
														<img src="@/assets/img/booking/booking-01.jpg" alt="User">
													</div>
													<div class="appointment-content">
														<h6>Wing Sports Academy</h6>
														<p class="color-green">Court 1</p>
													</div>
												</div>
											</li>
											<li>
												<h6>Price Per Guest</h6>
												<p>$15</p>
											</li>
											<li>
												<h6>Maximum Number of Guests</h6>
												<p>2</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Player Information</h4>
									</div>
									<div class="appointment-info appoin-border ">
										<ul>
											<li>
												<div class="appointment-item">
													<div class="appointment-img">
														<img src="@/assets/img/booking/booking-02.jpg" alt="User">
													</div>
													<div class="appointment-content">
														<h6>Martina</h6>
														<p>Since 05/05/2023</p>
													</div>
												</div>
											</li>
											<li>
												<h6>Previosly Booked</h6>
												<p>22 Jan 2023</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Appointment Information</h4>
									</div>
									<div class="appointment-info appoin-border mb-0">
										<ul>
											<li>
												<h6>Booked On</h6>
												<p>Mon, Jul 14</p>
											</li>
											<li>
												<h6>Booking Type</h6>
												<p>Onetime</p>
											</li>
											<li>
												<h6>Number Of Hours</h6>
												<p>2</p>
											</li>
											<li>
												<h6>Date & Time</h6>
												<p>Mon, Jul 14</p>
												<p>05:00 PM - 08:00 PM</p>
											</li>
										</ul>
									</div>
								</div>
								<form>
									<div class="reason-court">
										<label>Reason</label>
										<textarea class="form-control" rows="3" name="text"
											placeholder="Enter Reject Reson"></textarea>
									</div>
								</form>
							</div>
						</div>
						<!-- /Court Request -->

					</div>
					<div class="modal-footer">
						<div class="table-accept-btn">
							<a href="javascript:;" class="btn accept-btn me-0">Submit</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Request Reject -->

		<!-- Request Reject -->
		<div class="modal custom-modal fade request-modal" id="request-coche" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-md">
				<div class="modal-content">
					<div class="modal-header">
						<div class="form-header modal-header-title">
							<h4 class="mb-0">Coaching Reject Reason</h4>
						</div>
						<a class="close" data-bs-dismiss="modal" aria-label="Close">
							<span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
						</a>
					</div>
					<div class="modal-body">

						<!-- Court Request -->
						<div class="row">
							<div class="col-lg-12">
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Court Information</h4>
									</div>
									<div class="appointment-info">
										<ul>
											<li>
												<div class="appointment-item">
													<div class="appointment-img">
														<img src="@/assets/img/booking/booking-01.jpg" alt="User">
													</div>
													<div class="appointment-content">
														<h6>Wing Sports Academy</h6>
														<p class="color-green">Court 1</p>
													</div>
												</div>
											</li>
											<li>
												<h6>Price Per Guest</h6>
												<p>$15</p>
											</li>
											<li>
												<h6>Maximum Number of Guests</h6>
												<p>2</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Player Information</h4>
									</div>
									<div class="appointment-info appoin-border ">
										<ul>
											<li>
												<div class="appointment-item">
													<div class="appointment-img">
														<img src="@/assets/img/booking/booking-02.jpg" alt="User">
													</div>
													<div class="appointment-content">
														<h6>Martina</h6>
														<p>Since 05/05/2023</p>
													</div>
												</div>
											</li>
											<li>
												<h6>Previosly Booked</h6>
												<p>22 Jan 2023</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="card dashboard-card court-information">
									<div class="card-header">
										<h4>Appointment Information</h4>
									</div>
									<div class="appointment-info appoin-border mb-0">
										<ul>
											<li>
												<h6>Booked On</h6>
												<p>Mon, Jul 14</p>
											</li>
											<li>
												<h6>Booking Type</h6>
												<p>Onetime</p>
											</li>
											<li>
												<h6>Number Of Hours</h6>
												<p>2</p>
											</li>
											<li>
												<h6>Date & Time</h6>
												<p>Mon, Jul 14</p>
												<p>05:00 PM - 08:00 PM</p>
											</li>
										</ul>
									</div>
								</div>
								<form>
									<div class="reason-court">
										<label>Reason</label>
										<textarea class="form-control" rows="3" name="text"
											placeholder="Enter Reject Reson"></textarea>
									</div>
								</form>
							</div>
						</div>
						<!-- /Court Request -->

					</div>
					<div class="modal-footer">
						<div class="table-accept-btn">
							<a href="javascript:;" class="btn accept-btn me-0">Submit</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Request Reject -->
</template>